import { render, staticRenderFns } from "./supplier_edit.vue?vue&type=template&id=b7aff3ea&scoped=true"
import script from "./supplier_edit.vue?vue&type=script&lang=js"
export * from "./supplier_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7aff3ea",
  null
  
)

export default component.exports